import { render, staticRenderFns } from "./Dispose7.vue?vue&type=template&id=23cd237c&scoped=true&"
import script from "./Dispose7.vue?vue&type=script&lang=js&"
export * from "./Dispose7.vue?vue&type=script&lang=js&"
import style0 from "./Dispose7.vue?vue&type=style&index=0&id=23cd237c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cd237c",
  null
  
)

export default component.exports